import InputSupports from './InputSupports';
export default InputSupports;